import Cookies from 'js-cookie';

const cookieOption = { domain: window.location.hostname.indexOf('.radishfiction.com') > 0 ? '.radishfiction.com' : undefined, path: '/' };

class Session {
  set({ username, accessToken, thumbUrl = '' }: any) {
    Cookies.set('username', username, cookieOption);
    Cookies.set('token', accessToken, cookieOption);
    Cookies.set('thumbUrl', thumbUrl, cookieOption);
  }

  get(): { username: string; accessToken: string; thumbUrl?: string } | undefined {
    const username = Cookies.get('username');
    const accessToken = Cookies.get('token');
    const thumbUrl = Cookies.get('thumbUrl');

    if (username && accessToken) {
      return { username, accessToken, thumbUrl };
    }

    return undefined;
  }

  remove() {
    Cookies.remove('username', cookieOption);
    Cookies.remove('token', cookieOption);
    Cookies.remove('thumbUrl', cookieOption);
  }
}

export default new Session();
